// components/ModalLineas.js
import React, { useState, useEffect } from 'react';
import {
  Modal,
  Table,
  Button,
  Space,
  Tag,
  Typography,
  message,
  Card,
  Row,
  Col,
  Statistic,
  Tabs,
  Badge,
  Descriptions,
  Avatar,
  Tooltip
} from 'antd';
import {
  UserOutlined,
  IdcardOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CalendarOutlined,
  HomeOutlined,
  TeamOutlined,
  EyeOutlined,
  FileTextOutlined,
  EditOutlined,
  SaveOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL } from '../utils/constants';
import dayjs from 'dayjs';
import LectorDNI from './LectorDNI';
// IMPORTAMOS EL NUEVO COMPONENTE
import ParticularModal from './ParticularModal';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const ModalLineas = ({ visible, onClose, numReserva, linea, nombreCliente, codigoHotel }) => {

  console.log(" datos  ModalLineas => ",numReserva,linea);
  

  const [loading, setLoading] = useState(false);
  const [lineas, setLineas] = useState([]);
  const [lectorDNIVisible, setLectorDNIVisible] = useState(false);
  const [lineaSeleccionada, setLineaSeleccionada] = useState(null);
  
  // ESTADOS PARA EL MODAL DE PARTICULAR
  const [particularModalVisible, setParticularModalVisible] = useState(false);
  const [particularData, setParticularData] = useState({
    codParti: null,
    nombre: '',
    telefono: '',
    email: '',
    fechaEntrada: null,
    linea: null,
    numOcupante: null
  });

  const [resumenLineas, setResumenLineas] = useState({
    total: 0,
    ocupantes: 0,
    conCheckin: 0,
    sinCheckin: 0,
    conDNI: 0,
    sinDNI: 0
  });

  // Cargar líneas al abrir el modal
  useEffect(() => {
    if (visible && numReserva) {
      cargarLineas();
    }
  }, [visible, numReserva]);

  const cargarLineas = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        // `${BASE_URL}/api/reservas/${numReserva}/lineas`,
        `${BASE_URL}/api/reservas/${numReserva}/lineas/${linea}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        const datos = response.data.data;
        setLineas(datos);
        
        // Calcular resumen
        const ocupantesUnicos = [...new Set(datos.map(l => `${l.NumReserva}-${l.Linea}-${l.Numocupante}`))];
        const conCheckin = datos.filter(l => l.Entro === true || l.Entro === 1).length;
        const conDNI = datos.filter(l => l.DNI && l.DNI !== '' && l.DNI !== null).length;
        
        setResumenLineas({
          total: datos.length,
          ocupantes: ocupantesUnicos.length,
          conCheckin: conCheckin,
          sinCheckin: datos.length - conCheckin,
          conDNI: conDNI,
          sinDNI: datos.length - conDNI
        });
      }
    } catch (error) {
      console.error('Error cargando líneas:', error);
      message.error('Error al cargar las líneas de la reserva');
    } finally {
      setLoading(false);
    }
  };

  // Abrir lector DNI para una línea específica
  const abrirLectorDNI = (record) => {
    setLineaSeleccionada(record);
    setLectorDNIVisible(true);
  };

  // ABRIR MODAL DE DATOS PERSONALES
  const abrirParticularModal = (record) => {
    // console.log("📝 Abriendo datos personales para:", record);
    
    setParticularData({
      codParti: record.CodParti || null,
      nombre: record.Nombre || '',
      telefono: record.Telefono1 || '',
      email: record.EMail || '',
      fechaEntrada: record.Entrada || null,
      linea: record.Linea,
      numOcupante: record.Numocupante || 1
    });
    
    setLineaSeleccionada(record);
    setParticularModalVisible(true);
  };

  // Cuando se guarda el particular correctamente
  const handleParticularGuardado = async (codParti, data) => {
    // console.log("✅ Particular guardado:", codParti, data);
    message.success(`Datos del ocupante actualizados correctamente`);
    
    // Recargar líneas para actualizar el estado
    await cargarLineas();
  };

  // Cuando se procesa el DNI correctamente
  const handleDNIProcesado = async (data) => {
    // console.log('DNI procesado:', data);
    message.success(`DNI procesado para ${data.nombre} ${data.apellido1}`);
    
    // Recargar líneas para actualizar el estado
    await cargarLineas();
    
    // Cerrar lector después de 1 segundo
    setTimeout(() => {
      setLectorDNIVisible(false);
      setLineaSeleccionada(null);
    }, 1000);
  };

  // Obtener color de estado
  const getEstadoColor = (record) => {
    if (record.Entro === true || record.Entro === 1) {
      return 'green';
    }
    return 'orange';
  };

  const getEstadoTexto = (record) => {
    if (record.Entro === true || record.Entro === 1) {
      return 'Checkin Realizado';
    }
    return 'Pendiente';
  };

  // Columnas de la tabla
  const columns = [
    {
      title: 'Línea',
      dataIndex: 'Linea',
      key: 'linea',
      width: 80,
      render: (linea) => <Tag color="blue">#{linea}</Tag>
    },
    {
      title: 'Ocupante',
      dataIndex: 'Numocupante',
      key: 'numocupante',
      width: 80,
      render: (num, record) => (
        <Avatar 
          size="small" 
          style={{ 
            backgroundColor: record.Entro === 1 ? '#52c41a' : '#faad14',
            marginRight: 8
          }}
        >
          {num}
        </Avatar>
      )
    },
    {
      title: 'Nombre',
      dataIndex: 'Nombre',
      key: 'nombre',
      width: 200,
      render: (nombre, record) => (
        <Space direction="vertical" size={0}>
          <Text strong>{nombre}</Text>
          {record.Nacion && <Text type="secondary" style={{ fontSize: 12 }}>{record.Nacion}</Text>}
        </Space>
      )
    },
    {
      title: 'DNI',
      dataIndex: 'DNI',
      key: 'dni',
      width: 150,
      render: (dni, record) => (
        dni ? (
          <Tag color="green" icon={<CheckCircleOutlined />}>
            {dni}
          </Tag>
        ) : (
          <Tag color="orange" icon={<CloseCircleOutlined />}>
            No registrado
          </Tag>
        )
      )
    },
    {
      title: 'Tipo',
      key: 'tipo',
      width: 120,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Tag color="cyan">{record.TipoHabDesc || record.TipoHab}</Tag>
          <Text type="secondary" style={{ fontSize: 11 }}>
            {record.TipoFacDesc || record.TipoFac}
          </Text>
        </Space>
      )
    },
    {
      title: 'Fechas',
      key: 'fechas',
      width: 200,
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Text style={{ fontSize: 12 }}>
            <CalendarOutlined /> Entrada: {dayjs(record.Entrada).format('DD/MM/YYYY')}
          </Text>
          <Text style={{ fontSize: 12 }}>
            Salida: {dayjs(record.Salida).format('DD/MM/YYYY')}
          </Text>
        </Space>
      )
    },
    {
      title: 'Estado',
      dataIndex: 'Estado',
      key: 'estado',
      width: 120,
      render: (_, record) => (
        <Badge 
          status={record.Entro === 1 ? 'success' : 'warning'} 
          text={record.Entro === 1 ? 'Checkin ✔' : 'Pendiente'}
        />
      )
    },
    {
      title: 'Acciones',
      key: 'acciones',
      width: 200,
      fixed: 'right',
      render: (_, record) => (
        <Space>

          <Tooltip title="Datos personales del ocupante">
            <Button
              type="primary"
              icon={<UserOutlined />}
              size="small"
              onClick={() => abrirParticularModal(record)}
            >
              Datos
            </Button>
          </Tooltip>

          <Tooltip title="Leer DNI">
            <Button
              type={record.DNI ? "default" : "primary"}
              icon={<IdcardOutlined />}
              size="small"
              onClick={() => abrirLectorDNI(record)}
            >
              {record.DNI ? 'Actualizar' : 'Leer DNI'}
            </Button>
          </Tooltip>
        </Space>
      )
    }
  ];

  // Agrupar líneas por número de línea para mostrar mejor
  const lineasAgrupadas = lineas.reduce((acc, linea) => {
    const key = `${linea.Linea}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(linea);
    return acc;
  }, {});

  return (
    <>
      <Modal
        title={
          <Space>
            <TeamOutlined />
            <span>Líneas de Reserva</span>
            <Tag color="blue">#{numReserva}</Tag>
            {nombreCliente && <Text type="secondary">- {nombreCliente}</Text>}
          </Space>
        }
        open={visible}
        onCancel={onClose}
        width={1300}
        footer={[
          <Button key="close" onClick={onClose}>
            Cerrar
          </Button>
        ]}
      >
        {/* Tarjetas de resumen */}
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col span={6}>
            <Card size="small">
              <Statistic
                title="Total Ocupantes"
                value={resumenLineas.ocupantes}
                prefix={<UserOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card size="small">
              <Statistic
                title="Checkin Realizado"
                value={resumenLineas.conCheckin}
                suffix={`/ ${resumenLineas.total}`}
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card size="small">
              <Statistic
                title="Con DNI"
                value={resumenLineas.conDNI}
                suffix={`/ ${resumenLineas.total}`}
                prefix={<IdcardOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col span={6}>
            <Card size="small">
              <Statistic
                title="Sin DNI"
                value={resumenLineas.sinDNI}
                prefix={<IdcardOutlined />}
                valueStyle={{ color: '#faad14' }}
              />
            </Card>
          </Col>
        </Row>

        {/* Tabla de líneas */}
        <Table
          columns={columns}
          dataSource={lineas}
          rowKey={(record) => `${record.NumReserva}-${record.Linea}-${record.Numocupante}`}
          loading={loading}
          scroll={{ x: 1100 }}
          pagination={{ pageSize: 10 }}
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ margin: 0, paddingLeft: 24 }}>
                <Descriptions size="small" column={3} bordered>
                  <Descriptions.Item label="Localizador">{record.SNumero || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Régimen">{record.Regimen || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Agencia">{record.NomAgencia || 'Directa'}</Descriptions.Item>
                  <Descriptions.Item label="Serie Entrada">{record.SerEntrada || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Serie Salida">{record.SerSalida || '-'}</Descriptions.Item>
                  <Descriptions.Item label="Colocación">{record.Colocacion || '-'}</Descriptions.Item>
                  {record.DNI && (
                    <>
                      <Descriptions.Item label="DNI" span={3}>
                        <Tag color="green">{record.DNI}</Tag>
                      </Descriptions.Item>
                    </>
                  )}
                </Descriptions>
              </div>
            ),
            rowExpandable: (record) => true
          }}
        />
      </Modal>

      {/* Lector de DNI */}
      <LectorDNI
        visible={lectorDNIVisible}
        onClose={() => {
          setLectorDNIVisible(false);
          setLineaSeleccionada(null);
        }}
        onSuccess={handleDNIProcesado}
        numReserva={numReserva}
        linea={lineaSeleccionada?.Linea}
        numOcupante={lineaSeleccionada?.Numocupante}
        nombreCliente={lineaSeleccionada?.Nombre}
      />

      {/* MODAL DE DATOS PERSONALES DEL OCUPANTE */}
      <ParticularModal
        visible={particularModalVisible}
        onClose={() => {
          setParticularModalVisible(false);
          setLineaSeleccionada(null);
        }}
        onSuccess={handleParticularGuardado}
        codigoHotel={codigoHotel || 1}
        numReserva={numReserva}
        linea={particularData.linea}
        numOcupante={particularData.numOcupante}
        codParti={particularData.codParti}
        nombreReserva={particularData.nombre}
        telefonoReserva={particularData.telefono}
        emailReserva={particularData.email}
        fechaEntrada={particularData.fechaEntrada}
        tipoReserva="Hotel"
      />
    </>
  );
};

export default ModalLineas;